import React, { useState } from 'react';
import { User } from 'new/entities/User';
import { TextField } from 'new/elements/TextField';
import { Autocomplete } from 'new/elements/Autocomplete';
import cx from 'classnames';
import styles from 'new/elements/ResourceCollaboration/ResourceCollaboration.module.scss';
import { createFilterOptions, Typography } from '@mui/material';
import { useOrgMembers } from 'new/hooks/adapters/useOrgMembers';

interface MembersInputProps {
  onSelect?: (member: User) => void;
  initialValue?: User;
}

const AutocompleteOption = (props, option) => {
  const caption = option.full_name;
  const body3 = option.email;
  return (
    <div
      {...props}
      className={cx(
        styles.autocompleteOptionContainer,
        props['aria-selected'] ? styles.autocompleteOptionContainer_selected : '',
      )}
    >
      <Typography variant="body2">{caption}</Typography>
      <Typography variant="body3">{body3}</Typography>
    </div>
  );
};

const filterOptions = createFilterOptions({
  stringify: (option: User) => `${option.full_name}-${option.email}`,
});

export const MembersInput = (props: MembersInputProps) => {
  const [person, setPerson] = useState<User>(props.initialValue);
  const members = useOrgMembers();

  const onPersonChange = (e, person) => {
    setPerson(person);
    props.onSelect(person);
  };
  return (
    <Autocomplete
      value={person}
      options={members}
      clearOnEscape
      renderOption={AutocompleteOption}
      filterOptions={filterOptions}
      getOptionLabel={(option: User) => option.full_name}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      filterSelectedOptions
      onChange={onPersonChange}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label="Find by full name or email"
          value={person?.full_name || ''}
        />
      )}
    />
  );
};
